<script setup>

import TaskEmail from "./taskEmail.vue";
import TaskMessage from "./taskMessage.vue";
import { computed } from 'vue';

const emit = defineEmits(['markTaskSent'])

const props = defineProps({
    task: {
        type: Object,
        required: true
    },
    context: {
        type: String,
        default: 'email'
    },
    defaultEmailSubject: {
        type: String,
        required: false,
        default: '',
    },
    defaultEmailBody: {
        type: String,
        required: false,
        default: '',
    },
    defaultMessage: {
        type: String,
        required: false,
        default: '',
    },
})

const getDomainFromEmail = (email) => {
    if (!email) return null;
    const parts = email.split('@');
    return parts.length > 1 ? parts[1] : null;
}

const taskDomain = computed(() => getDomainFromEmail(props.task.email))

const markAsSent = () => {
    emit('markTaskSent', props.task);
}

</script>

<template>

    <div>
        <div class="mb-4">
            <div
                v-if="task.leadExists"
                class="mb-2"
            >
                <small
                    class="px-2 py-1 -ml-2 text-xs text-white rounded-md bg-myflowGreen-900"
                >{{ _mft('leadHunter:alreadyInYourContacts') }}</small>
            </div>
            <div class="flex justify-between">
                <h2>
                    {{ task.name }}
                </h2>
                <button-success
                    size="sm"
                    @click="markAsSent"
                >
                    {{ _mft('leadHunter:markAsSent') }}
                </button-success>
            </div>
            <div>
                <p>
                    <b>{{ _mft('leadHunter:contact.title') }}:</b> {{ task.job_title }}<br>
                    <b>{{ _mft('leadHunter:contact.company') }}:</b> {{ task.company }}
                </p>
            </div>
        </div>
        <div class="mb-4">
            <div>
                <a :href="'mailto:'+task.email" target="_blank">
                    <i class="w-5 text-lg text-gray-500 fa-regular fa-envelope"></i>
                </a>
                <span class="select-all">{{ task.email }}</span>
            </div>
            <div>
                <a
                    :href="task.linkedin_url"
                    target="_blank"
                    class="flex items-center leading-none hover:text-gray-500"
                >
                    <i class="w-5 text-lg text-gray-500 fa-brands fa-linkedin"></i>
                    <span class="pl-1">LinkedIn</span>
                </a>
            </div>
        </div>
        <div v-if="context === 'email'">
            <TaskEmail
                v-if="! task.personalized_subject || ! task.personalized_message"
                :subject="defaultEmailSubject"
                :body="defaultEmailBody"
                :personalized="false"
                :lead_id="task.id"
                :domain="taskDomain"
            />
            <TaskEmail
                v-else
                :subject="task.personalized_subject"
                :body="task.personalized_message"
                :personalized="true"
                :lead_id="task.id"
                :domain="taskDomain"
            />
        </div>

        <div v-if="context === 'linkedin'">
            <TaskMessage
                v-if="! task.personalizedMessage"
                :message="defaultMessage"
                :lead_id="task.id"
                :personalized="false"
            />
            <TaskMessage
                v-else
                :message="task.personalizedMessage"
                :personalized="true"
                :lead_id="task.id"
            />
        </div>
    </div>

</template>

<style scoped>

</style>
